import { IconType, Icons } from "../Icon"
import { ILogLighting, IShipVesselType } from "../../Types"

export function lightingValues(vesselType: IShipVesselType | undefined): ILogLighting[] {
  const values = Object.values(ILogLighting).filter((value): value is ILogLighting => typeof value == "number");
  return vesselType == IShipVesselType.motor
    ? values.filter((value) => value == ILogLighting.none || value == ILogLighting.anchorBall || value == ILogLighting.anchorLight || value == ILogLighting.motoringRunningLights)
    : values;
}

export function lightingTranslationKey(lighting: ILogLighting, vesselType: IShipVesselType | undefined): string {
  const name = vesselType == IShipVesselType.motor && lighting == ILogLighting.motoringRunningLights
    ? "navigationLights"
    : ILogLighting[lighting];
  return `LogButton_lighting_${name}`;
}

export function lightingIcon(lighting: ILogLighting | undefined): IconType {
  switch (lighting) {
    case ILogLighting.triColorLights:
      return Icons.LightingTricolor;
    case ILogLighting.anchorBall:
      return Icons.LightingAnchorBall;
    case ILogLighting.anchorLight:
      return Icons.LightingAnchorLight;
    case ILogLighting.sailingRunningLights:
      return Icons.LightingSailingRunning;
    case ILogLighting.motoringRunningLights:
      return Icons.LightingMotoringRunning;
    case ILogLighting.motoringCone:
      return Icons.LightingMotoringCone;
    case ILogLighting.none:
    default:
      return Icons.LightingNone;
  }
}
